export const SUBSCRIPTION_TIERS = {
  free: 'free',
  standard: 'standard',
  professional: 'professional',
  enterprise: 'enterprise'
} as const

export type SubscriptionTier = keyof typeof SUBSCRIPTION_TIERS

export const TIER_FEATURES = {
  free: {
    name: 'Free',
    price: 0,
    description: 'Try out basic features and explore opportunities',
    features: [
      'Basic dashboard access',
      'Company profile creation',
      'Limited opportunity viewing',
      'Basic search functionality'
    ]
  },
  standard: {
    name: 'Standard',
    price: 49,
    description: 'Essential tools for growing businesses',
    features: [
      'Everything in Free, plus:',
      'Full dashboard access',
      'Automated opportunity matching based on company profile',
      'Access to all State and Federal Opportunities Nationwide',
      'Basic analytics',
      'Automated email notifications',
      'AI-powered chatbot support'
    ]
  },
  professional: {
    name: 'Professional',
    price: 149,
    description: 'Comprehensive solution for established contractors',
    features: [
      'Everything in Standard, plus:',
      'Full GovRAG system access',
      'Advanced analytics',
      'AI-driven opportunity insights'
    ]
  },
  enterprise: {
    name: 'Enterprise',
    price: null,
    description: 'Coming Soon: Custom solutions for large contractors',
    features: [
      'Everything in Professional, plus:',
      'Custom integrations',
      'Team collaboration tools',
      'Advanced AI features',
      'Dedicated account manager',
      'Custom AI model training',
      '24/7 priority support'
    ]
  }
}

export function hasAccess(userTier: SubscriptionTier, requiredTier: SubscriptionTier): boolean {
  const tiers = Object.keys(SUBSCRIPTION_TIERS) as SubscriptionTier[]
  const userTierIndex = tiers.indexOf(userTier)
  const requiredTierIndex = tiers.indexOf(requiredTier)
  
  return userTierIndex >= requiredTierIndex
}

export function getFeatures(tier: SubscriptionTier): string[] {
  return TIER_FEATURES[tier]?.features || []
}

export function getTierPrice(tier: SubscriptionTier): number {
  return TIER_FEATURES[tier]?.price || 0
} 